/**
 * Get the base URL where our build assets are served from.
 * 
 * In WordPress, the JS bundle is loaded via wp_enqueue_script with an absolute URL
 * like: https://example.com/wp-content/plugins/my-plugin/app/build/static/js/main.abc123.js
 * 
 * We derive the build root from the script's src, so that imported assets
 * (which webpack outputs as relative paths like ./static/media/hero.svg)
 * resolve correctly regardless of the page URL.
 */

let _baseUrl = null;

function getBaseUrl() {
  if (_baseUrl !== null) return _baseUrl;

  // Try to find our script tag by looking for the main bundle filename pattern
  const scripts = document.querySelectorAll('script[src]');
  for (const script of scripts) {
    const src = script.getAttribute('src');
    if (src && src.includes('/static/js/main.')) {
      // Extract everything before /static/js/main.xxx.js
      const idx = src.indexOf('/static/js/main.');
      _baseUrl = src.substring(0, idx).replace(/\/\.$/, '');
      return _baseUrl;
    }
  }

  // Fallback: use empty string (relative to page, works for localhost dev server)
  _baseUrl = '';
  return _baseUrl;
}

/**
 * Resolve an imported asset URL to the correct absolute URL.
 * 
 * @param {string} assetImport - The webpack-imported asset (e.g., import heroSvg from './hero.svg')
 * @returns {string} The correct URL to use in <img src>
 */
export function getAssetUrl(assetImport) {
  // On dev server (localhost), the import already works correctly
  if (!assetImport) return '';

  // If it's already an absolute URL or data URL, return as-is
  if (assetImport.startsWith('http') || assetImport.startsWith('data:')) {
    return assetImport;
  }

  const base = getBaseUrl();

  // If no base found (dev server), return the import as-is
  if (!base) return assetImport;

  // Strip leading ./ from the webpack import path
  const cleanPath = assetImport.replace(/^\.\//, '/');

  return base + cleanPath;
}
